/**
 * Local Experiences Section Component
 * Displays local experiences in a vertical list layout
 * Follows Single Responsibility Principle - only responsible for rendering the section with items
 */

import React from 'react';
import { spacing } from '@/design-system/utils';
import { SectionHeader } from '@/components/ui/section-header';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { LocalExperienceList } from './LocalExperienceList';
import { LocalExperiencesSectionProps } from './types';

/**
 * Local Experiences Section Component
 * Renders a vertical list of local experience items with responsive layout
 */
export const LocalExperiencesSection: React.FC<
  LocalExperiencesSectionProps
> = ({ title = 'Local Experiences', items, className, placeName }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[3],
      }}
      className={className}
    >
      <SectionHeader title={title} />
      <LocalExperienceList
        items={items}
        placeName={placeName}
        isMobile={isMobile}
      />
    </div>
  );
};
